import { Box, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

interface IPhaseHeaderProps {
  titleKey: string;
  descriptionKey: string;
}

export const PhaseHeader = memo(
  ({ titleKey, descriptionKey }: IPhaseHeaderProps) => {
    const { t } = useTranslation();

    return (
      <Grid item xs={12}>
        <Box sx={{ bgcolor: "action.hover", borderRadius: 1, px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" fontWeight="bold" display="block">
            {t(translationPath + titleKey)}
          </Typography>
          <Typography variant="body2" color="text.secondary" display="block">
            {t(translationPath + descriptionKey)}
          </Typography>
        </Box>
      </Grid>
    );
  },
);
